import type { ReactElement } from 'react';

import ErrorState from 'app/shared-components/common/ErrorState';

interface PlanFeaturesErrorStateProps {
  onRetry: () => void;
}

export default function PlanFeaturesErrorState({
  onRetry,
}: PlanFeaturesErrorStateProps): ReactElement {
  return (
    <ErrorState
      title="We couldn't load your plan"
      subtitle="Check your connection and try again."
      action={{ label: 'Try again', onClick: onRetry }}
    />
  );
}
